document.addEventListener('DOMContentLoaded', function () {
  const productGrid = document.querySelector('#product-grid');
  if (!productGrid) return;

  const paginationWrapper = document.querySelector('.pagination-wrapper');
  if (paginationWrapper) paginationWrapper.style.display = 'none';

  function getNextUrl() {
    const nextLink = document.querySelector('.pagination-wrapper a.pagination__item--prev');
    return nextLink ? nextLink.href : null;
  }

  let nextUrl = getNextUrl();
  if (!nextUrl) return;

  const wrapper = document.createElement('div');
  wrapper.id = 'load-more-wrapper';
  wrapper.style.cssText = 'text-align:center; margin: 2rem 0;';
  wrapper.innerHTML = '<button class="button button--secondary" id="load-more-btn">Indlæs flere produkter</button>';
  document.querySelector('#ProductGridContainer').after(wrapper);

  document.getElementById('load-more-btn').addEventListener('click', function () {
    const btn = this;
    btn.textContent = 'Indlæser...';
    btn.disabled = true;

    fetch(nextUrl)
      .then(r => r.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newItems = doc.querySelectorAll('#product-grid li');
        newItems.forEach(item => productGrid.appendChild(item));

        const newPagination = doc.querySelector('.pagination-wrapper');
        if (newPagination) {
          document.querySelector('.pagination-wrapper').innerHTML = newPagination.innerHTML;
          nextUrl = getNextUrl();
        } else {
          nextUrl = null;
        }

        if (!nextUrl) {
          wrapper.style.display = 'none';
        } else {
          btn.textContent = 'Indlæs flere produkter';
          btn.disabled = false;
        }
      });
  });
});
